import { match } from 'ts-pattern';

export const MDM_TYPES = [
  'Intune',
  'Lanscope',
  'Miradore',
  'JamfPro',
  'ManageEngine',
] as const;
export type MdmTypeValue = (typeof MDM_TYPES)[number];

export const getMdmTypeLabel = (
  mdmType: string | undefined,
  mdmTypeLabel?: string,
): string => {
  if (mdmTypeLabel) return mdmTypeLabel;
  if (!mdmType) return 'Unknown';

  return match(mdmType as MdmTypeValue)
    .with('Intune', () => 'Microsoft Intune')
    .with('Lanscope', () => 'LANSCOPE')
    .with('Miradore', () => 'Miradore')
    .with('JamfPro', () => 'Jamf Pro')
    .with('ManageEngine', () => 'ManageEngine')
    .otherwise(() => mdmType);
};
